import React, { useContext, useEffect, useRef, useState } from "react";
import {
  DocumentDuplicateIcon,
  DocumentIcon,
  DocumentTextIcon,
  PencilIcon,
  PlusIcon,
  PrinterIcon,
  TrashIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import toast from "react-hot-toast";
import { confirmAlert } from "react-confirm-alert";
import * as XLSX from "xlsx"; // xlsx: for exporting excel file. Use xlsx to convert the table data into Excel format and trigger the download.

import { useReactToPrint } from "react-to-print";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import { SiMicrosoftexcel } from "react-icons/si";
import { FaFilePdf } from "react-icons/fa6";
import { ImPrinter } from "react-icons/im";
import { FaCopy } from "react-icons/fa6";
import { FaEdit } from "react-icons/fa";
import { TableSkeleton } from "../../../../Reusable/skeleton/TableSkeleton";
import { UserContext } from "../../../../Context/UserContext";
import { BaseURL } from "../../../../Reusable/BaseURL";
import MyInput from "../../../../Reusable/MyInput";

export default function GRNCreatePageForm({
  editBtn,
  firstPageList,
  links,
  firstPage,
  setGetId,
  spinner,
  totalNo,
  from,
  to,
  addMoreToggle,
  setAddMoreToggle,
  getUnsavedItemList,
  editDisable,
  setFirstPage,
}) {
  const { darkTheme, loginData } = useContext(UserContext);
  const [searchInp, setSearchInp] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [searchTotalNo, setSearchTotalNo] = useState(0);
  const [searchFrom, setSearchFrom] = useState(0);
  const [searchTo, setSearchTo] = useState(0);
  const [view, setView] = useState([]);
  const [searchSpinner, setSearchSpinner] = useState(true);

  useEffect(() => {
    // divisionList()
    // firstPageList(); // or getUnsavedItemList();
  }, []);

  // function divisionList(){
  //   fetch(`${BaseURL}/divisions`,{
  //     method: "GET",
  //     headers:{
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`
  //     }
  //   }).then(res=> res.json())
  //   .then(li=> {
  //     if(li?.status){
  //       setView(li.data.data);
  //     }
  //   });
  // }

  // CONFIRM ALERT FOR DELETE A RECORD=================
  function deleteARecord(id) {
    const options = {
      // title: "Are you sure?",
      message: "You want to delete this record?",
      buttons: [
        {
          label: "Yes",
          onClick: () => deleteConfirm(),
        },
        {
          label: "No",
          // onClick: () => alert('Click No')
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      keyCodeForClose: [8, 32],
      willUnmount: () => {},
      afterClose: () => {},
      onClickOutside: () => {},
      onKeypress: () => {},
      onKeypressEscape: () => {},
      overlayClassName: "overlay-custom-class-name",
    };
    async function deleteConfirm() {
      await fetch(`${BaseURL}/purchase/indent/deletecacheitem/${id}`, {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${loginData.token}`,
        },
      })
        .then((resjson) => resjson.json())
        .then((deleteRes) => {
          firstPageList();
          toast.success("Deleted!");
        });
    }
    confirmAlert(options);
  }

  function searchList(searchValue) {
    setSearchSpinner(true);
    fetch(`${BaseURL}/divisions?q=${searchValue}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((search) => {
        setSearchData(search.data.data);
        setSearchTotalNo(search.total);
        setSearchFrom(search.from);
        setSearchTo(search.to);
        setSearchSpinner(false);
      });
  }

  // COPY TO CLIPBOARD
  const copyToClipboard = () => {
    let data = "S.No.\tName\n";
    if (firstPage.length > 0 && searchInp === "") {
      firstPage.forEach((row, index) => {
        data += `${index + 1}\t${row.name}\n`;
      });
    } else if (searchInp !== "" && searchInp.length > 0) {
      searchData.forEach((row, index) => {
        data += `${index + 1}\t${row.name}\n`;
      });
    }

    navigator.clipboard.writeText(data).then(
      () => {
        toast.success("Table data copied to clipboard");
      },
      (err) => {
        // console.error('Could not copy text: ', err);
        toast.error("Could not copy text");
      }
    );
  };

  // DOWNLOAD EXCEL BTN
  const exportToExcel = () => {
    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Create a worksheet from the table data
    const ws = XLSX.utils.json_to_sheet(firstPage);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Generate Excel file and trigger download
    XLSX.writeFile(wb, "Division_table_data_excel.xlsx");
  };

  // // PRINT BTN
  // const PrintTable = () => {
  //   const printContents = document.getElementById('tablePrn').outerHTML;
  //   const originalContents = document.body.innerHTML;

  //   document.body.innerHTML = printContents;
  //   window.print();
  //   document.body.innerHTML = originalContents;
  // };

  // PDF/Print BTN-download
  const tableRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => tableRef.current,
  });

  const handleDownloadPdf = async () => {
    const element = tableRef.current;
    const canvas = await html2canvas(element);
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF();
    pdf.addImage(imgData, "PNG", 0, 0);
    pdf.save("Division_table_pdf.pdf");
  };
  //close - pdf btn download

  // MODIFY PREVIOUS & NEXT BTN
  // const previousBtn = links[0].replace("&laquo; ", "<");
  // let endPostn = links.length-1;
  // let nextBtn = links[endPostn];
  // nextBtn.replace(" &raquo;", "<")
  // console.log("nextBtn", nextBtn);

  const inputHandler = (index, value, inputName, itemQty) => {
    const decimalRegex = /^-?\d+(\.\d{0,2})?$/;
    // if (decimalRegex.test(value)) {
      setFirstPage((prev) => {
        const data = [...prev];
        data[index][inputName] = value;
        data[index] = { ...data[index], inputName: value };

        // const amount = data[index].quoted_unit_rate * itemQty;
        // const famount = amount - data[index].discount;
        // const namount = data[index].negotiation_rate * itemQty;

        data[index] = {
          ...data[index],
          grn_amount: data[index].grn_unit_rate * data[index].grn_qty,
          // final_amount:
          //   data[index].quoted_unit_rate * itemQty - data[index].discount,
          // negotiation_amount: data[index].negotiation_rate * itemQty,
        };

        // calcNegotiationAmountTotal(data);
        return data;
      });
    // }
  };

  return (
    <div>
      {/* TABLE DOWNLOAD BTNs */}
      {/* <div className="mb-2">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <div>
            <MyInput
              value={searchInp}
              onInput={(e) => {
                setSearchInp(e.target.value);
                searchList(e.target.value);
              }}
              placeholder="Auto Search.."
              type="text"
              className="w-[260px]"
            />
          </div>
          <div className="flex gap-1">
            <Button
              className="py-1 px-[10px]"
              title="Copy"
              onClick={copyToClipboard}
            >
              <FaCopy className="w-4 h-4" />
            </Button>
            <Button
              className="py-1 px-[10px] bg-green-700"
              title="Excel"
              onClick={exportToExcel}
            >
              <SiMicrosoftexcel className="w-4 h-4" />
            </Button>
            <Button
              className="py-1 px-[10px] bg-red-600"
              title="PDF"
              onClick={() => handleDownloadPdf()}
            >
              <FaFilePdf className="w-4 h-4" />
            </Button>
            <Button
              className="py-1 px-[10px] bg-[#6d6e70]"
              title="Print"
              onClick={() => handlePrint()}
            >
              <ImPrinter className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </div> */}

      {/* TABLE-RECORDS */}
      <div
        ref={tableRef}
        // className="scrollBar relative overflow-x-auto shadow-md sm:rounded-lg"
        className="scrollBar relative overflow-x-auto overflow-y-auto shadow-md sm:rounded-lg h-auto max-h-[800px]"
      >
        <table
          id="tablePrn"
          className={`w-full text-[11px] uppercase text-left rtl:text-right ${
            darkTheme
              ? "text-gray-500 bg-slate-200"
              : "text-gray-400 bg-slate-100"
          }`}
        >
          <thead
            className={`${
              darkTheme
                ? "bg-gray-700 text-gray-400"
                : "bg-gray-50 text-gray-700"
            }`}
          >
            <tr>
              <th className="px-3 py-3">Action</th>
              <th scope="col" className="px-3 py-3">
                <div className="flex items-center">
                  S.No.
                  <a href="#">
                    <svg
                      className="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" className="px-3 py-3">
                <div className="flex items-center">
                  Division
                  <a href="#">
                    <svg
                      className="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" className="px-3 py-3">
                <div className="flex items-center">
                  Item Name
                  <a href="#">
                    <svg
                      className="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" className="px-3 py-3">
                <div className="flex items-center">
                  Brand
                  <a href="#">
                    <svg
                      className="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" className="px-3 py-3">
                <div className="flex items-center">
                  Unit
                  <a href="#">
                    <svg
                      className="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" className="px-3 py-3">
                <div className="flex items-center">
                  Qty
                  <a href="#">
                    <svg
                      className="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" className="px-3 py-3">
                <div className="flex items-center">
                  Receiving Qty
                  <a href="#">
                    <svg
                      className="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" className="px-3 py-3">
                <div className="flex items-center">
                  Rate
                  <a href="#">
                    <svg
                      className="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" className="px-3 py-3">
                <div className="flex items-center">
                  Amount
                  <a href="#">
                    <svg
                      className="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg>
                  </a>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {searchInp !== "" ? (
              searchData.length > 0 ? (
                <>
                  {searchData.map((item, index) => (
                    <tr
                      key={item.id}
                      className={`border-b ${
                        darkTheme ? "bg-gray-800 border-gray-700" : "bg-white "
                      }`}
                    >
                      <td scope="col" className="px-3 py-3">
                        <div className="flex items-center gap-4">
                          {/* <button disabled={editDisable}>
                            <FaEdit
                              disabled={editDisable}
                              onClick={() => {
                                editBtn(item);
                                setGetId(item.id);
                              }}
                              className={
                                "w-4 h-4 font-medium " +
                                (darkTheme
                                  ? "text-blue-500 hover:text-blue-400"
                                  : "text-[#00334e] hover:text-blue-500")
                              }
                            />
                          </button> */}

                          <TrashIcon
                            onClick={() => {
                              deleteARecord(item.id);
                            }}
                            className={
                              "w-4 h-4 font-medium " +
                              (darkTheme
                                ? "text-blue-500 hover:text-blue-400"
                                : "text-red-500 hover:text-red-400")
                            }
                          />
                        </div>
                      </td>
                      <td scope="row" className="px-3 py-2 whitespace-nowrap">
                        {index + 1}
                      </td>
                      <td scope="row" className="px-3 py-2 whitespace-nowrap">
                        {item.division}
                      </td>
                      <td scope="row" className="px-3 py-2 whitespace-nowrap">
                        {item.item_name}
                      </td>
                      <td scope="row" className="px-3 py-2 whitespace-nowrap">
                        {item.brand}
                      </td>
                      <td scope="row" className="px-3 py-2 whitespace-nowrap">
                        {item.unit}
                      </td>
                      <td scope="row" className="px-3 py-2 whitespace-nowrap">
                        {item.qty}
                      </td>
                    </tr>
                  ))}
                </>
              ) : searchSpinner ? (
                // <tr
                //   className={`border-b ${
                //     darkTheme ? "bg-gray-800 border-gray-700" : "bg-white "
                //   }`}
                // >
                //   <th className="px-3 py-1 text-center" colSpan={3}>
                //     <Spinner loading={searchSpinner} />
                //   </th>
                // </tr>
                <TableSkeleton rows={2} columns={10} />
              ) : (
                <tr
                  className={`border-b ${
                    darkTheme ? "bg-gray-800 border-gray-700" : "bg-white "
                  }`}
                >
                  <th
                    className="px-3 py-1 text-red-500 text-center"
                    colSpan={3}
                  >
                    No record
                  </th>
                </tr>
              )
            ) : firstPage.length > 0 ? (
              firstPage.map((item, index) => (
                <tr
                  key={item.id}
                  className={`border-b ${
                    darkTheme ? "bg-gray-800 border-gray-700" : "bg-white "
                  }`}
                >
                  <td scope="col" className="px-3 py-3">
                    <div className="flex items-center gap-4">
                      {/* <button disabled={editDisable}>
                        <FaEdit
                          disabled={editDisable}
                          onClick={() => {
                            editBtn(item);
                            setGetId(item.id);
                          }}
                          className={
                            "w-4 h-4 font-medium " +
                            (darkTheme
                              ? "text-blue-500 hover:text-blue-400"
                              : "text-[#00334e] hover:text-blue-500")
                          }
                        />
                      </button> */}

                      <TrashIcon
                        onClick={() => {
                          deleteARecord(item.id);
                        }}
                        className={
                          "w-4 h-4 font-medium " +
                          (darkTheme
                            ? "text-blue-500 hover:text-blue-400"
                            : "text-red-500 hover:text-red-400")
                        }
                      />
                    </div>
                  </td>
                  <td scope="row" className="px-3 py-2 whitespace-nowrap">
                    {index + 1}
                  </td>
                  <td scope="row" className="px-3 py-2 whitespace-nowrap">
                    {item.division}
                  </td>
                  <td scope="row" className="px-3 py-2 whitespace-nowrap">
                    {item.item_name}
                  </td>
                  <td scope="row" className="px-3 py-2 whitespace-nowrap">
                    {item.brand}
                  </td>
                  <td scope="row" className="px-3 py-2 whitespace-nowrap">
                    {item.unit}
                  </td>
                  <td scope="row" className="px-3 py-2 whitespace-nowrap">
                    {item.qty}
                  </td>
                  <td scope="row" className="px-3 py-2 whitespace-nowrap">
                    <MyInput
                      type="number"
                      placeholder="Receiving Qty"
                      value={item.grn_qty}
                      onChange={(event) =>
                        inputHandler(
                          index,
                          event.target.value,
                          "grn_qty",
                          item.qty
                        )
                      }
                      className="!py-0.5"
                      // readOnly
                    />
                  </td>
                  <td scope="row" className="px-3 py-2 whitespace-nowrap">
                    <MyInput
                      type="number"
                      placeholder="Rate"
                      value={item.grn_unit_rate}
                      onChange={(event) =>
                        inputHandler(
                          index,
                          event.target.value,
                          "grn_unit_rate",
                          item.qty
                        )
                      }
                      className="!py-0.5"
                      // readOnly
                    />
                  </td>
                  <td scope="row" className="px-3 py-2 whitespace-nowrap">
                    <MyInput
                      type="number"
                      placeholder="Amount"
                      value={item.grn_amount}
                      onChange={(event) =>
                        inputHandler(
                          index,
                          event.target.value,
                          "grn_amount",
                          item.qty
                        )
                      }
                      className="!py-0.5"
                      readOnly
                    />
                  </td>
                </tr>
              ))
            ) : spinner ? (
              // <tr
              //   className={`border-b ${
              //     darkTheme ? "bg-gray-800 border-gray-700" : "bg-white "
              //   }`}
              // >
              //   <th className="px-3 py-1 text-center" colSpan={3}>
              //     <Spinner loading={spinner} />
              //   </th>
              // </tr>
              <TableSkeleton rows={3} columns={10} />
            ) : (
              <tr
                className={`border-b ${
                  darkTheme ? "bg-gray-800 border-gray-700" : "bg-white "
                }`}
              >
                <th className="px-3 py-1 text-red-500 text-center" colSpan={3}>
                  No record
                </th>
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr
              className={`border-b ${
                darkTheme ? "bg-gray-800 border-gray-700" : "bg-white "
              }`}
            >
              <th className="px-3 py-1"></th>
              <th className="px-3 py-1">S.No.</th>
              <th className="px-3 py-1">Division</th>
              <th className="px-3 py-1">Item Code/Name</th>
              <th className="px-3 py-1">Brand</th>
              <th className="px-3 py-1">Unit</th>
              <th className="px-3 py-1">Qty</th>
            </tr>
          </tfoot>
        </table>
        {/* <div
          className={`flex gap-1 items-center justify-between px-2 py-2 text-[12px]`}
        >
          <div>
            Showing {searchFrom !== 0 ? searchFrom : from} to{" "}
            {searchTo !== 0 ? searchTo : to} of{" "}
            {searchTotalNo !== 0 ? searchTotalNo : totalNo}-entries
          </div>
          <div className="flex gap-1 items-center overflow-x-auto scrollBar">
            {links.length > 0 &&
              links.map((item, index) => (
                <button
                  key={index}
                  onClick={() => firstPageList(item.url)}
                  className={`py-[2px] px-[10px] md:py-1 md:px-2 text-[13px] rounded-xl ${
                    item.active && "bg-blue-200 cursor-not-allowed"
                  } ${darkTheme && item.active && "bg-blue-500"}`}
                >
                  {index === 0 ? (
                    <>{item.label.replace("&laquo; Previous", "<")}</>
                  ) : index === links.length - 1 ? (
                    <>{item.label.replace("Next &raquo;", ">")}</>
                  ) : (
                    <>{item.label}</>
                  )}
                </button>
              ))}
          </div>
        </div> */}
      </div>
    </div>
  );
}
